import { render, staticRenderFns } from "./SingleValues.vue?vue&type=template&id=3e41f4ca&scoped=true"
import script from "./SingleValues.vue?vue&type=script&lang=js"
export * from "./SingleValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e41f4ca",
  null
  
)

export default component.exports